export default __webpack_public_path__ + "static/media/Common__xvid.b6df2fac.mp4";